export enum ActivationSource {
	Card = 'card',
	Sheet = 'sheet'
}

export enum ActivationResult {
	Success = 'true',
	Failure = 'error'
}